import React, { useEffect, useState } from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import { useParams } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProjectDetails.css";

const ProjectDetails = () => {
  let { projectId } = useParams();
  const [project, setProject] = useState([]);

  var settings = {
    dots: true,
    focusOnSelect: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    fetch(`/projects.json`)
      .then((res) => res.json())
      .then((data) => {
        const filterData = data.filter((project) => project.id === projectId);
        setProject(filterData?.[0]);
      });
  }, [projectId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="pb-5 pt-3 mb-5 w-100" style={{ minHeight: "100vh" }}>
      <p className="fw-bold text-center fs-1 mb-4">{project.name}</p>
      <Container>
        <Slider {...settings}>
          <div className="mx-2">
            <div className="mx-3">
              <img className="img-fluid rounded-3" src={project.img1} alt="" />
            </div>
          </div>
          <div className="mx-2">
            <div className="mx-3">
              <img className="img-fluid rounded-3" src={project.img2} alt="" />
            </div>
          </div>
          <div className="mx-2">
            <div className="mx-3">
              <img className="img-fluid rounded-3" src={project.img3} alt="" />
            </div>
          </div>
        </Slider>
      </Container>
      <div className="py-4 container text-white">
        <Tabs
          defaultActiveKey="description"
          id="uncontrolled-tab-example"
          className="mb-3 text-danger"
        >
          <Tab eventKey="description" title="Description">
            <h6>
              <span className="fw-bold">Name of the project: </span>
              {project.name}
            </h6>
            <hr />
            <h6>
              <span className="fw-bold">Technology Used: </span>
              {project.technology}
            </h6>
            <hr />
            <h6>
              <span className="fw-bold"> Description: </span>
              {project.description}
            </h6>
            <hr />
          </Tab>
          <Tab eventKey="Links" title="Links 🔗">
            <button className="btn btn-danger m-2">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href={project.live}
                rel="noreferrer"
                target="_blank"
              >
                <i className="fas fa-link text-white"></i> Live Site Link
              </a>
            </button>

            <button className="btn btn-danger m-2">
              <a
                style={{ textDecoration: "none", color: "white" }}
                href={project.gitClient}
                rel="noreferrer"
                target="_blank"
              >
                <i className="fas fa-link text-white"></i> Client-Side Link
              </a>
            </button>

            {project.gitServer !== "" && (
              <button className="btn btn-danger m-2">
                <a
                  style={{ textDecoration: "none", color: "white" }}
                  href={project.gitServer}
                  rel="noreferrer"
                  target="_blank"
                >
                  <i className="fas fa-link text-white"></i> Server-Side Link
                </a>
              </button>
            )}

            <hr />
          </Tab>
        </Tabs>
      </div>
    </Container>
  );
};

export default ProjectDetails;
